var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsUnread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 22 16",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000",
      strokeWidth: 1.5,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(-4 -10)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.625 13.1666667v10.3125c0 .7593915-.6156085 1.375-1.375 1.375h-16.5c-.75939153 0-1.375-.6156085-1.375-1.375v-10.3125l7.9264167 6.2874166c.9970174.7830533 2.4001492.7830533 3.3971666 0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4906667 18.0323333 2.6968333 2.6968334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.5093333 18.0323333-2.6968333 2.6968334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5.375 13v-.625c0-.7593915.61560847-1.375 1.375-1.375h16.5c.7593915 0 1.375.6156085 1.375 1.375v.625l-7.9264167 6.2874167c-.9970174.7830533-2.4001492.7830533-3.3971666 0z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsUnread);
export default __webpack_public_path__ + "static/media/notifications-unread.5147bc53d8408c6503b315946507ab20.svg";
export { ForwardRef as ReactComponent };